import { types as sdkTypes } from './util/sdkLoader';

const { LatLng, LatLngBounds} = sdkTypes;

// An array of locations to show in the LocationAutocompleteInput when
// the input is in focus but the user hasn't typed in any search yet.
//
// Each item in the array should be an object with a unique `id` (String) and a
// `predictionPlace` (util.types.place) properties.
export default [
  {
    id: 'default-Peru',
    predictionPlace: {
      address: 'Peru',
      bounds: new LatLngBounds(new LatLng(-2.09938354,-64.58707437), new LatLng(-17.60072067,-84.01683308)),
      origin: new LatLng(-19.08484945,-88.36464458)
      

    },

  },
  {
    id: 'default-Tanzania',
    predictionPlace: {
      address: 'Tanzania',
      bounds: new LatLngBounds(new LatLng(-2.28154153, 39.52658853), new LatLng(-10.75272501, 29.96128522)),
      origin: new LatLng(-10.75272501, 29.96128522)
    },
  },
  {
    id: 'default-Thailand',
    predictionPlace: {
      address: 'Thailand',
      bounds: new LatLngBounds(new LatLng(19.58825493,107.90035503), new LatLng(11.87356814,98.02581673)),
      origin: new LatLng(11.55015697,96.86961658)
  },
  },
  {
    id: 'default- Italien',
    predictionPlace: {
      address: ' Italien',
      bounds: new LatLngBounds(new LatLng(47.06901179,22.19523811), new LatLng(34.84473041,2.17461996)),
      origin: new LatLng(43.70040457,5.95054692)
    },
  },
  // {
  //   id: 'default-ruka',
  //   predictionPlace: {
  //     address: 'Ruka',
      // bounds: new LatLngBounds(new LatLng(66.16997, 29.16773), new LatLng(66.16095, 29.13572)),
  //   },
  // },
];
